export default function FloatingCTAs() {
  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3">
      {/* Phone CTA */}
      <a
        href="tel:+4529678107"
        className="w-14 h-14 bg-brand-orange hover:bg-brand-orange-hover text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl cursor-pointer"
        aria-label="Ring til os"
        title="Ring til os"
      >
        <i className="fa-solid fa-phone text-xl"></i>
      </a>

      {/* Email CTA */}
      <a
        href="mailto:kontakt@baw-byg.dk"
        className="w-14 h-14 bg-brand-blue hover:bg-brand-blue-hover text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl cursor-pointer"
        aria-label="Send en mail"
        title="Send en mail"
      >
        <i className="fa-solid fa-envelope text-xl"></i>
      </a>

      {/* Facebook CTA */}
      <a
        href="https://www.facebook.com/bawbyg/"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-[#1877F2] hover:bg-[#166FE5] text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 hover:shadow-xl cursor-pointer"
        aria-label="Besøg os på Facebook"
        title="Besøg os på Facebook"
      >
        <i className="fa-brands fa-facebook-f text-xl"></i>
      </a>
    </div>
  )
}
